import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar"; // Sidebar component
import Header from "./Header"; // Header component
import Footer from "./Footer"; // Footer component
import Dashboard from "./Dashboards/Dashboard"; // Dashboard page
import Transactions from "./Transaction/TransactionTable"; // Analytics page
import Profile from "./Profile/ProfilePage"; // Analytics page
import GitManagement from "./Transaction/TransactionTable"; // Analytics page
import Orders from "./Transaction/TransactionTable"; // Analytics page
import ReportsTable from "./Reports/ReportsTable";
import ProtectedRoute from "./ProtectedRoute";
import WhatsAppButton from "./WhatsAppButton";
import "./MainLayout.css"; // Import layout styles
import { ROProvider } from "./Dashboards/ROContext";

const MainLayout = () => {
  return (
    <ROProvider>
    <div className="main-layout">
      {/* Header */}
      <Header />

      {/* Main Content: Sidebar + Dynamic Content */}
      <div className="content">
        <Sidebar /> {/* Sidebar is always visible */}

        {/* Right Side: Renders component based on the URL path */}
        <div className="dashboard-container">
          <Routes>
             {/* Protected Route for Dashboard */}
             <Route element={<ProtectedRoute />}>
                    <Route path="/Dashboard" element={<Dashboard />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/transaction" element={<Transactions />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/orders" element={<Orders />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                    <Route path="/gift-management" element={<GitManagement />} />
                </Route>
                <Route path="/reports" element={<ReportsTable />} />
                <Route element={<ProtectedRoute />}>
                    <Route path="/profile" element={<Profile />} />
                </Route>
           
            {/* Add more routes as needed  <Route path="/transaction" element={<Transactions />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/gift-management" element={<GitManagement />} />
            <Route path="/profile" element={<Profile />} />*/}
          </Routes>
        </div>
      </div>
      <WhatsAppButton />  {/* WhatsApp Button visible on all pages */}
      {/* Footer */}
      <Footer />
    </div>
    </ROProvider>
  );
};

export default MainLayout;
